import { httpCreate } from './http';

const http = httpCreate('/srv/applet');

export const applet = {
	getToken() {
		return http.get(`/getToken`);
	},
};
